export const FETCH_VENUES_REQUEST = 'FETCH_VENUES_REQUEST'
export const FETCH_VENUES_FULFILLED = 'FETCH_VENUES_FULFILLED'
export const FETCH_VENUES_ERRED = 'FETCH_VENUES_ERRED'
export const SET_SELECTED_VENUE = 'SET_SELECTED_VENUE'
export const SELECT_NEAREST_VENUE = 'SELECT_NEAREST_VENUE'
